export default __webpack_public_path__ + "static/media/MERN-realtime-messenger.c210a5aa.jpg";